import { useNavigate } from 'react-router-dom';
import { Screen } from '../../app/Frame';
import { useScreen, useToast } from '../../app/shell-context';
import { ApiError } from '../../api/client';
import { useCreateChild } from '../api';
import { useOnboarding } from '../OnboardingContext';

/** Первый вход, шаг 2: о ком заботимся. Карточка ребёнка заводится сразу. */
export function ChildStep() {
  const navigate = useNavigate();
  const toast = useToast();
  const { nb, patch } = useOnboarding();
  const createChild = useCreateChild();

  const age = Number(nb.age);
  const ready = nb.name.trim().length > 1 && age > 0;

  useScreen('О ребёнке', {
    label: createChild.isPending ? 'Секунду…' : 'Далее',
    disabled: !ready || createChild.isPending,
    onClick: () => next(),
  });

  function next() {
    // Ребёнок уже заведён (вернулись назад и снова вперёд) — второй раз не создаём.
    if (nb.childId) {
      navigate('/onboarding/direction');
      return;
    }
    createChild.mutate(
      {
        name: nb.name.trim(),
        birthYear: age > 0 ? new Date().getUTCFullYear() - age : null,
        note: nb.note.trim(),
      },
      {
        onSuccess: (child) => {
          patch({ childId: child.id });
          navigate('/onboarding/direction');
        },
        onError: (e) => {
          if (e instanceof ApiError && e.is('CONTACT_REQUIRED')) {
            toast('Сначала телефон и согласие');
            navigate('/onboarding', { replace: true });
            return;
          }
          toast(e instanceof ApiError ? e.message : 'Не получилось завести карточку');
        },
      },
    );
  }

  return (
    <Screen>
      <div>
        <p className="eyebrow">Шаг 2 из 3</p>
        <p className="lead" style={{ marginTop: 6 }}>
          О ком будем заботиться. Позже можно добавить второго ребёнка.
        </p>
      </div>

      <div className="two">
        <div className="field">
          <label htmlFor="nbName">Имя ребёнка</label>
          <input id="nbName" type="text" placeholder="Матвей" value={nb.name} onChange={(e) => patch({ name: e.target.value })} />
        </div>
        <div className="field">
          <label htmlFor="nbAge">Возраст</label>
          <input
            id="nbAge"
            type="number"
            min="3"
            max="17"
            placeholder="7"
            inputMode="numeric"
            value={nb.age}
            onChange={(e) => patch({ age: e.target.value })}
          />
        </div>
      </div>

      <div className="field">
        <label htmlFor="nbReq">Что беспокоит</label>
        <textarea
          id="nbReq"
          placeholder="Трудно удерживать внимание на уроках, жалобы от учителя"
          value={nb.note}
          onChange={(e) => patch({ note: e.target.value })}
        />
        <span className="hint">Своими словами — специалист прочитает до встречи.</span>
      </div>
    </Screen>
  );
}
